export enum MembershipStatus {
  ACTIVE = 'Active',
  DENIED = 'Denied',
  DISABLED = 'Disabled',
  PENDING = 'Pending'
}


// WEBPACK FOOTER //
// ./src/modules/communities/types/MembershipStatus.ts